import Api from '../../../services/api';

// Telas que aceitam configuração automática por IA: submenus de "% Indicadores" do DRE e atividades do DFC.
export const AI_CONFIG_TARGET = {
  dre: 'dre',
  kpi: 'kpi',
  financialGroups: 'financialGroups',
  dfc: 'dfc',
};

export const dreAiConfigApi = {
  // Só sugere: o backend lê DRE/categorias/contexto da empresa e devolve a proposta validada.
  // O DFC tem endpoint próprio (mesmo serviço no backend, uso medido separado).
  suggest: (syncId, target) =>
    (target === AI_CONFIG_TARGET.dfc
      ? Api.post(`/sync/${syncId}/dfc/ai-suggest`, {}, { timeout: 180000 })
      : Api.post(`/sync/${syncId}/dre-indicators/ai-suggest`, { target }, { timeout: 180000 })
    ).then(({ data }) => data),
};
